'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { Backdrop, CircularProgress } from '@mui/material';
import { useIndicatorStore } from '@/stores/indicator.store';

const Indicator = () => {
  const { showIndicator, setShowIndicator } = useIndicatorStore((state) => state);

  const pathname = usePathname();

  useEffect(() => {
    if (showIndicator) {
      setShowIndicator(false);
    }
  }, [pathname]);

  return (
    <Backdrop sx={{ color: '#fff', zIndex: 9999 }} open={showIndicator}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default Indicator;
